const billingUserMenus = [
  {
    icon: "edit",
    key: "configuration.billing-cdr",
    name: "Billing CDR",
    url: "home/app/billing/Cdr",
    description: "Billing-CDR",
    productionReady: true,
  },
  {
    icon: "phone_callback",
    key: "rawCdrReport",
    name: "Raw CDR Report",
    url: "home/app/rawCdrReport",
    description: "Search raw CDRs by number and time; trace related call legs",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "details",
    key: "billingcdrdetails",
    name: "Extension CDR Details",
    url: "home/app/billingcdrdetails",
    description: "Extension CDR Details",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "details",
    key: "Feature.Extension.CDR.Details",
    name: "Feature Extension CDR Details",
    url: "home/app/FeatureExtensionCDRDetails",
    description: "Feature Extension CDR Details",
    productionReady: true,
    disabled: false,
  },
];

export { billingUserMenus };
